/* eslint-disable no-use-before-define */
/* eslint-disable no-promise-executor-return */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import UserService from '@/services/UserService';

export const setUserPreferencesAsync = createAsyncThunk(
  'userPreferences/userPreferencesAsync',
  async () => {
    const data = await UserService.getConfigSetting();
    return data;
  }
);

// Initial state
const initialState = {};

// Actual Slice
export const UserPreferencesSlice = createSlice({
  name: 'UserPreferences',
  initialState,
  reducers: {
    setUserPreferencesState(state, action) {
      state = action.payload;
    },
    setSidebarCollapseState(state, action) {
      state.sidebarCollapse = action.payload;
    },
    setRightbarCollapseState(state, action) {
      state.rightbarCollapse = action.payload;
    },
    setFavouriteSelectedTabState(state, action) {
      state.favouriteSelectedTab = action.payload;
    },
    setHideWhatAreStarringRules(state) {
      state.hideWhatAreStarringRules = true;
    },
    setHideWhatAreWebcontactRules(state) {
      state.hideWhatAreWebcontactRules = true;
    },
    setHideControlListingInfoBanner(state) {
      state.hideControlListingInfoBanner = true;
    },
    setDashboardConfig(state, action) {
      state.dashboardConfig = action.payload;
    },
    setLeadsDisplayPreference(state, action) {
      state.showLeadsKanban = action.payload === 'kanban';
      state.leadsDisplayPreferenceTouched = true;
      state.leadsDisplayPreferenceReady = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setUserPreferencesAsync.fulfilled, (state, action) => {
      const {
        calendar_preferences,
        favourite_selected_tab,
        rightbar_collapse,
        search_config,
        sidebar_collapse,
        what_are_smart_publishing,
        what_are_webcontact_rules,
        control_listing_creation_info,
        leads_display_preference,
        dashboard_config,
      } = action.payload.user_preferences;
      const defaultFavouriteSelectedTab = 'properties';

      state.calendarPreferences = calendar_preferences;
      state.favouriteSelectedTab =
        favourite_selected_tab || defaultFavouriteSelectedTab;
      state.rightbarCollapse = rightbar_collapse;
      state.searchConfig = search_config;
      state.sidebarCollapse = sidebar_collapse;
      state.tokkoMessengerURL = action.payload['tokko-messenger-url'];
      state.hideWhatAreStarringRules = what_are_smart_publishing;
      state.hideWhatAreWebcontactRules = what_are_webcontact_rules;
      state.hideControlListingInfoBanner = control_listing_creation_info;
      state.leadsDisplayPreferenceReady = true;
      if (!state.leadsDisplayPreferenceTouched) {
        state.showLeadsKanban = leads_display_preference === 'kanban';
      }
      state.dashboardConfig = dashboard_config;
    });
    // The app loader keeps the skeleton when this request fails, so this
    // default does not open the leads list in production. It covers a mount
    // that happens after a rejected fetch.
    builder.addCase(setUserPreferencesAsync.rejected, (state) => {
      state.leadsDisplayPreferenceReady = true;
      if (state.showLeadsKanban === undefined) state.showLeadsKanban = false;
    });
  },
});

export const {
  setUserPreferencesState,
  setSidebarCollapseState,
  setRightbarCollapseState,
  setFavouriteSelectedTabState,
  setHideWhatAreStarringRules,
  setHideWhatAreWebcontactRules,
  setHideControlListingInfoBanner,
  setDashboardConfig,
  setLeadsDisplayPreference,
} = UserPreferencesSlice.actions;

export const selectUserPreferencesState = (state) => state.UserPreferencesSlice;

export const selectTokkoMessengerURL = (state) =>
  state.UserPreferencesSlice.tokkoMessengerURL;

export default UserPreferencesSlice.reducer;
